
















































import { ApplicationUserModel, PositionModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { positionsStore } from '@/libs/positions/+state/store';

@Component({})
export default class PositionDialog extends Page {

    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    position : PositionModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.position?.id == Guid.EmptyGuid();
    }
    
    open (id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close () {
        this.dialog = false;
    }

    private load (): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadPosition().then((e) => {
                    this.loading = false;
                    resolve(e);
                }).catch((e: any) => {
                    reject(e);
                });
            });
        }
        else {
            this.position = {
                id: Guid.EmptyGuid(),
                name: ""
            } as PositionModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadPosition() {
        return new Promise((resolve, reject) => {
            positionsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(positionsStore, CrudReponse.Get).then((e) => {
                this.position = e;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    private save () {
        if (this.form.validate()) {
            const position = {...this.position};
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                positionsStore.dispatch(CrudAction.Create, { item: position });
                this.subscribe(positionsStore, CrudReponse.Create).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
            else {
                positionsStore.dispatch(CrudAction.Update, { item: position });
                this.subscribe(positionsStore, CrudReponse.Update).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deletePosition () {
        this.deleting = true;
        positionsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(positionsStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
